/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'
import { withSessionStorage } from '@reatom/persist-web-storage'
import { createPath } from 'react-router'

import { STORAGE_PREFIX } from '@root/shared/constants'
import {
  browserHistory,
  lastVisitedRouterLocationAtom,
  routerActions,
  routerLocationAtom,
} from '@root/shared/lib/react-router/browser-router'

import { RootRoute } from '../model'

import type { Location } from 'react-router'

const lastNonAuthRouteAtom = atom<Location | undefined>(
  undefined,
  'lastNonAuthRouteAtom',
).pipe(
  withSessionStorage({
    key: `${STORAGE_PREFIX}/lastNonAuthRoute`,
  }),
)

export const redirectToLastVisitedNonAuthRouteAction = action((ctx) => {
  const location = ctx.get(routerLocationAtom)
  if (isNonAuthRoute(location)) {
    return
  }
  const lastVisitedNonAuthRoute = ctx.get(lastNonAuthRouteAtom)
  if (!lastVisitedNonAuthRoute) {
    routerActions.navigate(ctx, RootRoute.build())
    return
  }
  routerActions.navigate(ctx, createPath(lastVisitedNonAuthRoute))
}, 'redirectToLastVisitedNonAuthRouteAction')

export const initializeApplicationRouting = action((ctx) => {
  const initialLocation = ctx.get(routerLocationAtom)
  if (isNonAuthRoute(initialLocation)) {
    lastNonAuthRouteAtom(ctx, initialLocation)
  }

  ctx.subscribe(routerLocationAtom, (location) => {
    if (isNonAuthRoute(location)) {
      lastNonAuthRouteAtom(ctx, location)
    }
  })
})

const isNonAuthRoute = (route: Location) => {
  return !route.pathname.includes('/auth')
}

const lastVisitedNonAuthRouteAtom = atom((ctx) => {
  const lastEntry = ctx.spy(lastVisitedRouterLocationAtom)
  return lastEntry?.pathname.includes('/auth') ? undefined : lastEntry
}, 'lastVisitedNonAuthRouteAtom')

export const goBackAction = action((ctx) => {
  const lastEntry = ctx.get(lastVisitedNonAuthRouteAtom)
  if (lastEntry) {
    browserHistory.go(-1)
    return
  }

  routerActions.navigate(ctx, RootRoute.build())
}, 'handleBackAction')
